import React from 'react';

const DotLoader = ({ color = "#C04C2A", size = "w-2 h-2" }) => {
    return (
        <div className="flex items-center justify-center gap-1.5" aria-label="Loading">
            {/* Dot 1 */}
            <div
                className={`${size} rounded-full animate-bounce [animation-delay:-0.3s]`}
                style={{ backgroundColor: color }}
            ></div>
            {/* Dot 2 */}
            <div
                className={`${size} rounded-full animate-bounce [animation-delay:-0.15s]`}
                style={{ backgroundColor: color }}
            ></div>
            {/* Dot 3 */}
            <div
                className={`${size} rounded-full animate-bounce`}
                style={{ backgroundColor: color }}
            ></div>
        </div>
    );
};

export default DotLoader;